import { render, staticRenderFns } from "./comLegend.vue?vue&type=template&id=d788c686&"
import script from "./comLegend.vue?vue&type=script&lang=js&"
export * from "./comLegend.vue?vue&type=script&lang=js&"
import style0 from "./comLegend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports